import React, { useState } from 'react';

export const LoginPage: React.FC = () => {
    const [email, setEmail] = useState('biznesbezklikania@gmail.com');
    const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
    const [devLink, setDevLink] = useState<string | null>(null);

    async function submit(e: React.FormEvent) {
        e.preventDefault();
        setStatus('sending');
        try {
            const r = await fetch('/api/admin-auth/request', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await r.json();
            if (data.dev_link) setDevLink(data.dev_link);
            setStatus('sent');
        } catch {
            setStatus('error');
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-sm bg-white dark:bg-content-dark rounded-2xl p-6 shadow-lg border border-border-light dark:border-border-dark">
                <h1 className="text-2xl font-bold mb-1">BBK Admin</h1>
                <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark mb-4">
                    Magic-link wyślemy na e-mail (link działa 15 min).
                </p>
                <form onSubmit={submit} className="space-y-3">
                    <input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        className="w-full px-3 py-2 border rounded-md bg-bkg-light dark:bg-bkg-dark"
                    />
                    <button
                        type="submit"
                        disabled={status === 'sending'}
                        className="w-full bg-primary-light dark:bg-primary-dark text-white py-2 px-4 rounded-md font-semibold disabled:opacity-50"
                    >
                        {status === 'sending' ? 'Wysyłam…' : 'Wyślij magic-link'}
                    </button>
                </form>
                {status === 'sent' && (
                    <p className="text-sm text-green-600 mt-4">
                        Sprawdź skrzynkę. Jeśli używasz dev-mode, link jest poniżej.
                    </p>
                )}
                {devLink && (
                    <a href={devLink} className="block text-xs text-blue-500 underline mt-2 break-all">
                        DEV: {devLink}
                    </a>
                )}
                {status === 'error' && <p className="text-sm text-red-500 mt-3">Błąd. Spróbuj jeszcze raz.</p>}
            </div>
        </div>
    );
};
